import { useEffect, useState } from "react";
import axiosInstance from "../../api/axios.js";
import { useParams } from "react-router-dom";
import AuthTravelShell from "../../components/travel-theme/AuthTravelShell.js";

const PASSWORD_REGEX = /^(?=.*[0-9])(?=.*[-~!@#$%^&*()_?]).{8,}$/;

const ResetRequest = () => {
  const { token } = useParams();

  const [password, setPassword] = useState("");
  const [validPassword, setValidPassword] = useState(false);

  const [confirmPassword, setConfirmPassword] = useState("");
  const [validConfirmPassword, setValidConfirmPassword] = useState(false);

  const [message, setMessage] = useState("");

  useEffect(() => {
    setValidPassword(PASSWORD_REGEX.test(password));
    setValidConfirmPassword(password === confirmPassword);
  }, [password, confirmPassword]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axiosInstance.post(
        `/api/auth/reset_password/${token}`,
        { password }
      );
      setMessage(response.data.message);
    } catch (error) {
      setMessage(error.response.data.message);
    }
  };

  return (
    <AuthTravelShell
      eyebrow="Account recovery"
      title="Issue a new pass."
      description="Choose a new password to continue your HackPrinceton Fall 2026 journey."
      ticketCode="UPDATE"
    >
      <form className="auth-form" onSubmit={handleSubmit}>
        <p className="subtitle">Your new password must meet every requirement.</p>
        <div className="auth-form-inner">
          {message && (
            <p className="error-message" role="status">
              {message}
            </p>
          )}
          <div className="form-field">
            <label htmlFor="new-password">New password</label>
                <input
                  id="new-password"
                  name="password"
                  type="password"
                  placeholder="8+ characters"
                  maxLength={72}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="new-password"
                  aria-invalid={password && !validPassword ? "true" : "false"}
                  aria-describedby={password && !validPassword ? "password-error" : undefined}
                  required
                />
          </div>
          {password && !validPassword && (
            <p id="password-error" className="error-message">
              Use at least 8 characters, 1 number, and 1 special character.
            </p>
          )}
          <div className="form-field">
            <label htmlFor="confirm-new-password">Confirm password</label>
                <input
                  id="confirm-new-password"
                  name="confirmPassword"
                  type="password"
                  placeholder="Repeat your password"
                  maxLength={72}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  autoComplete="new-password"
                  aria-invalid={
                    password && confirmPassword && !validConfirmPassword
                      ? "true"
                      : "false"
                  }
                  aria-describedby={
                    password && confirmPassword && !validConfirmPassword
                      ? "confirm-password-error"
                      : undefined
                  }
                  required
                />
          </div>
          {password && confirmPassword && !validConfirmPassword && (
            <p id="confirm-password-error" className="error-message">
              The passwords must match.
            </p>
          )}
          <div className="auth-form__lower">
            <button
              type="submit"
              className="button"
              disabled={!validPassword || !validConfirmPassword}
            >
              Update password
            </button>
          </div>
        </div>
      </form>
    </AuthTravelShell>
  );
};

export default ResetRequest;
